module.exports = __webpack_public_path__ + "media/img/pages/profile/lidl ger 10-d46db688fe71ff7b41a9a96c928c9e3e.webp";